import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell8InchPortrait from 'public/images/tablet-shells/FireTabletsFeatureRotator_8inch_Portrait_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
} from '../constants';

export const TABLET_8INCH_PORTRAIT_FOS: PreviewStateConfig = {
  label: '8" Portrait',
  altText: ALT_TEXT,
  dimensions: { width: 800, height: 1280 },
  metadataZone: { top: 335, ctaTop: 573, safeZone: 65, leftMargin: 66 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 13,
        y: 315,
        width: 774,
        height: 345,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 13, y: 315, width: 387, height: 345 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 327,
        maxHeight: 133,
        position: { x: 66, y: 360 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 66,
        y: 513,
      },
      fontSize: 18,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 397,
      maxLines: MAX_LINES,
      lineHeight: 23,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 13, y: 315, width: 774, height: 20 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 13, y: 630, width: 774, height: 30 },
    },
    { type: LayerType.SHELL, src: shell8InchPortrait },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
